import { useMemo } from 'react';
import { matchRoutes } from 'react-router-config';
import { useLocation } from 'react-router-dom';

import routes from '../routes';

export const AUTH_GUARD_PRIVATE = 'AUTH_GUARD_PRIVATE';
export const AUTH_GUARD_ANONYMOUS_ONLY = 'AUTH_GUARD_ANONYMOUS_ONLY';

export default function useAuthGuard() {
  const { pathname } = useLocation();

  return useMemo(() => {
    const branch = matchRoutes(routes, pathname);

    for (let i = 0; i < branch.length; i++) {
      const { route } = branch[i];

      if (route.isPrivate) {
        return AUTH_GUARD_PRIVATE;
      }

      if (route.isAnonymousOnly) {
        return AUTH_GUARD_ANONYMOUS_ONLY;
      }
    }
  }, [pathname]);
}
